import { render, staticRenderFns } from "./ShLogMonitoramentoLogistico.vue?vue&type=template&id=5ae60442&scoped=true"
import script from "./ShLogMonitoramentoLogistico.vue?vue&type=script&lang=js"
export * from "./ShLogMonitoramentoLogistico.vue?vue&type=script&lang=js"
import style0 from "./ShLogMonitoramentoLogistico.vue?vue&type=style&index=0&id=5ae60442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae60442",
  null
  
)

export default component.exports